import type { Location } from '../types';

interface Props {
  selected: Location;
  onChange: (loc: Location) => void;
}

export function LocationTabs({ selected, onChange }: Props) {
  return (
    <div className="location-tabs">
      <button
        className={`location-tab ${selected === 'madras' ? 'location-tab--active location-tab--madras' : ''}`}
        onClick={() => onChange('madras')}
      >
        Madras
      </button>
      <button
        className={`location-tab ${selected === 'madurai' ? 'location-tab--active location-tab--madurai' : ''}`}
        onClick={() => onChange('madurai')}
      >
        Madurai
      </button>
    </div>
  );
}
